const configs = {
  development: {
    apiUrl: 'http://localhost:50388/',
    apiUrlAPI: 'http://localhost:50389/',
    siteUrl: 'http://localhost:8080',
    baseUrl: 'http://localhost:50388/',
    mktUrl: 'https://aldomarketing.aldo.com.br',
    imageUrl: 'https://www.aldo.com.br/cdn-cgi/image/quality=65/AldoMarketing',
  },

  'win-betadev01': {
    apiUrl: 'https://win-betadev01.aldo.com.br/wcf/',
    apiUrlAPI: 'https://win-betadev01.aldo.com.br/',
    siteUrl: 'https://win-betadev01.aldo.com.br',
    baseUrl: 'https://win-betadev01.aldo.com.br',
    mktUrl: 'https://aldomarketing.aldo.com.br',
    imageUrl: 'https://aldomarketing.aldo.com.br',
  },

  'production': {
    apiUrl: 'https://www.aldo.com.br/wcf/',
    apiUrlAPI: 'https://api.aldo.com.br/',
    siteUrl: 'https://www.aldo.com.br',
    baseUrl: 'https://www.aldo.com.br',
    mktUrl: 'https://aldomarketing.aldo.com.br',
    imageUrl: 'https://www.aldo.com.br/cdn-cgi/image/quality=65/AldoMarketing',
  },

  'production-new': {
    apiUrl: 'https://wcf.aldo.com.br/',
    apiUrlAPI: 'https://api.aldo.com.br/',
    siteUrl: 'https://app.aldo.com.br',
    baseUrl: 'https://wcf.aldo.com.br',
    mktUrl: 'https://aldomarketing.aldo.com.br',
    imageUrl: 'https://aldomarketing.aldo.com.br/',
  },
}

export default configs
